<template>
    <div class="container mt-3 mb-1 text-right">
            <button @click="reload()"  type="button" style="border-radius:22px;" class="btn btn-vino-o"><i class="fas fa-arrow-left"></i> Atrás</button>
    </div>
</template>
<script>
export default {
    methods:{
        reload(){
            window.location.reload();
        }
    }
}
</script>